<template>
	<a-modal class="client-modal-wrapper" width="702px" :mask-closable="false" :visible="isVisibleBrand" :footer="null"
		:title="title" @cancel="$emit('onCancel')">
		<basic-form ref="basicForm" :form-data="formData">
			<template #scene>
				<a-radio-group  @change="changeSelect" v-decorator="[
            'scene',
            {
              rules: [
                {
                  required: true,
                  message: '请指定资料使用场景',
                },
              ],
            },
          ]">
					<a-radio :value="1">传统任务</a-radio>
					<a-radio :value="2">远程任务</a-radio>
				</a-radio-group>
			</template>
			<template #need_seconds>
			   <a-slider  :min="5" :tipFormatter="tipFormatter" :max="300" :marks="videoTimeMarker" v-decorator="[
            'need_seconds',
            {
              rules: [
                {
                  required: true,
                  message: '请指定资料期望阅读时间',
                },
              ],
            },
          ]"/>
			</template>

			<template #name>
				<a-input v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入资料名称',
                },
              ],
            },
          ]" placeholder="请输入资料名称" />
			</template>
			<template #type>
				<a-select v-decorator="[
            'type',
            { rules: [{ required: true, message: '请选择资料类型' }] },
          ]" placeholder="请选择资料类型">
					<a-select-option v-for="item in academic_material" :key="item.key" :value="item.key">
						{{ item.name }}
					</a-select-option>
				</a-select>
			</template>
			<template #product_id>
				<a-select v-decorator="[
            'product_id',
            { rules: [{ required: true, message: '请选择关联产品' }] },
          ]" placeholder="请选择关联产品">
					<a-select-option v-for="item in productData" :key="item.id" :value="item.id">
						{{ item.title }}
					</a-select-option>
				</a-select>
			</template>

			<template #upload>
				<a-upload v-decorator="[
            'attach_doc_ids',
            {
              rules: [{ required: true, message: '请选择附件' }],
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]" name="upload" :with-credentials="false" :disabled="editType" :data="{ fileType: 'file' }"
					:action="`${uploadUrl}system/upload`" @change="handleChangeUpload" :remove="handleRemove">
					<a-button :disabled="editType">
						<a-icon type="upload" /> 点击上传
					</a-button>
					（请上传pdf的文件资料；如需修改资料请删除后上传）
				</a-upload>
			</template>
			<template #summary>
				<a-textarea v-decorator="[
            'summary',
          ]" rows="6" placeholder="请输入资料简要介绍" maxlength="150" />
			</template>
		</basic-form>
		<slot />
	</a-modal>
</template>
<script>
	import {
		companyFormData,
		serviceFormData
	} from "../data/index";
	export default {
		props: ["isVisibleBrand", "title", "companyIsDisabled", "limit", "editType"],
		data() {
			return {
				formData: [],
				academic_material: [],
				companyData: [],
				productData: [],
				show: false,
				fileList: [],
				token: "",
				scene: '',
				videoTimeMarker:{
					5: '5s',
					60: '1min',
					120: '2min',
					180: '3min',
					240: '4min',
					300: '5min',
				}
			};
		},
		mounted() {
			// 获取token
			this.token = localStorage.getItem("token");
			if (this.$store.state.user.role === 1) {
				this.formData = JSON.parse(JSON.stringify(serviceFormData));
			} else {
				this.formData = companyFormData;
			}
			// 获取合作企业
			this.getCompanyList();
			// 获取资料类型
			this.getSystemConfig();
			// 获取产品
			this.getProduct();
		},
		methods: {
			// 格式化拖动的时间
			tipFormatter(tip){
				let min = Math.floor(tip/60);
				let sec = tip%60;
				let timerstr = '';

				if(min && sec){
					timerstr = min+'min'+sec+'s';
				}else if(min && !sec){
					timerstr = min+'min';
				}else{
					timerstr = sec+'s';
				}
				return timerstr;
			},
			// 获取合作企业
			async getCompanyList() {
				let result = await this.$http.post("/Company/getCooperationCompanyList");
				if (result.data.status === 1) {
					this.companyData = result.data.data.data_list;
				}
			},
			reset(){
				this.formData =[]
				this.formData = JSON.parse(JSON.stringify(serviceFormData));
			},
			updateData(scene){
				if (scene == 2) {
					 this.formData.splice(1, 0, {
						name: 'need_seconds',
						lable: '期望阅读时长',
						lableCol: 4,
						wrapperCol: 18,
						offset: 0,
						span: 12,
					})
				}else{
					this.formData.map((item)=>{
						if(item.lable=='期望阅读时长'){
							this.formData.splice(1,1)
						}
					})
				}
			},
			// 获取合作企业
			async getProduct() {
				let result = await this.$http.post("/product/getList");
				if (result.data.status === 1) {
					this.productData = result.data.data.data_list;
				}
			},
			// 获取资料类型
			async getSystemConfig() {
				let result = await this.$http.post("/system/getConfigs");
				if (result.data.status === 1) {
					this.academic_material = result.data.data.academic_material;
				}
			},

			// 上传
			handleChangeUpload(event) {
				console.log(event);
				if (event.file.type && event.file.type !== "application/pdf") {
					this.$message.error("请上传pdf文件");
					event.fileList.splice(-1, 1);
				}
				if (this.limit) {
					if (event.fileList.length > 1) {
						this.$message.error("只能上传一个文件");
						event.fileList.splice(-1, 1);
					}
				}
				if (event.file.response && event.file.response.status === 0) {
					this.$message.warning(event.file.response.msg);
				}
			},

			handleRemove(event) {
				if (this.limit) {
					this.editType = false;
				}
			},
			normFile(e) {
				if (Array.isArray(e)) {
					return e;
				}
				let data = [];
				e.fileList.forEach((item) => {
					if (item.response && item.response.status === 0) {
						return;
					} else {
						data.push(item);
					}
				});
				e.fileList = data;
				return e && e.fileList;
			},
			changeSelect(key) {
				if (key.target.value == 2) {
					this.formData.splice(1, 0, {
						name: 'need_seconds',
						lable: '期望阅读时长',
						lableCol: 4,
						wrapperCol: 18,
						offset: 0,
						span: 12,
					})
				}else{
					this.formData.map((item)=>{
						if(item.lable=='期望阅读时长'){
							this.formData.splice(1,1)
						}
					})
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.client-modal-wrapper {
		.textarea {
			font-size: 12px;
			font-weight: 400;
			color: rgba(86, 92, 102, 1);
			position: relative;
			top: -37px;
			right: -550px;
		}
	}
</style>